import React, { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

interface ISectionHeadProps {
  children: ReactNode;
  /** Total items in the section — rendered as a pill next to the title. */
  count?: number;
}

const SectionHead: React.FC<ISectionHeadProps> = ({ children, count }) => (
  <Stack
    direction={'row'}
    alignItems={'center'}
    sx={{ gap: 1.75, mb: 2 }}
  >
    <Box sx={{ bgcolor: 'divider', flex: 1, height: '1px' }} />
    <Stack
      direction={'row'}
      alignItems={'center'}
      sx={{ flex: 'none', gap: 1 }}
    >
      <Typography sx={{ fontSize: 22, fontWeight: 800, m: 0 }}>
        {children}
      </Typography>
      {typeof count === 'number' && (
        <Box
          sx={(theme) => ({
            alignItems: 'center',
            bgcolor: alpha(theme.palette.primary.main, 0.12),
            borderRadius: 999,
            color: 'primary.main',
            display: 'inline-flex',
            fontSize: 13,
            fontWeight: 700,
            height: 24,
            justifyContent: 'center',
            minWidth: 24,
            px: 0.875,
          })}
        >
          {count}
        </Box>
      )}
    </Stack>
    <Box sx={{ bgcolor: 'divider', flex: 1, height: '1px' }} />
  </Stack>
);

export default SectionHead;
